import { render, staticRenderFns } from "./DashboardViewEditingName.vue?vue&type=template&id=68debe8a"
import script from "./DashboardViewEditingName.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports